module.exports = __webpack_public_path__ + "img/copy-clipboard.d86bda30.svg";